/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module NetworkSecurityPolicyModule
 */

/**
 * @fileoverview Contains Ajs dependency tokens for factories & services.
 *
 * @author Sarthak Kapoor, Abhinesh Gour
 */

/**
 * Token for Network Security Policy Item.
 */
export const NETWORK_SECURITY_POLICY_ITEM_TOKEN = 'NetworkSecurityPolicyItem';

/**
 * Token for Network Security Policy Collection.
 */
export const NETWORK_SECURITY_POLICY_COLLECTION_TOKEN = 'NetworkSecurityPolicyCollection';

/**
 * Ajs dependency token for NetworkSecurityRule configItem.
 */
export const NETWORK_SECURITY_RULE_CONFIG_ITEM_TOKEN = 'NetworkSecurityRuleConfigItem';

/**
 * Ajs dependency token for NetworkSecurityMatchTargetConfigItem configItem.
 */
export const NETWORK_SECURITY_MATCH_TARGET_CONFIG_ITEM_TOKEN =
    'NetworkSecurityMatchTargetConfigItem';
